module.exports = __webpack_public_path__ + "img/10.86bcd608.jpg";